import { useMemo } from "react";
import { buildPersonalDetailsSchema } from "pages/PersonalDetails";
import useStore from "state";
import { acceptsNationalAddresses } from "./GeneralUtils";

export const useNationalAddressesSchema = () => {
    const pricingResult = useStore((s) => s.pricing.result);
    const nationalAddresses = useMemo(() => acceptsNationalAddresses(pricingResult), [pricingResult]);
    const validationSchema = useMemo(() => buildPersonalDetailsSchema(nationalAddresses), [nationalAddresses]);
    return { nationalAddresses, validationSchema };
};
